import {AppStore} from '../../store/appStore';
import {
  SyncCellsListsReasonsEnum,
  trySyncUserCellsListsAsyncAction,
} from '../../store/metadata/cellsLists/cellsListsActions';

/*
 * API.
 */

// TODO: Move content refresh from PushContainer into this service.
export function setupInboxesRefresh(store: AppStore) {
  store.dispatch(trySyncUserCellsListsAsyncAction(SyncCellsListsReasonsEnum.BOOT));
}
